import React from "react"

import { NotificationManager } from "react-notifications"

import { gql, useMutation } from "hooks/urql"

export type HideButtonProps = {
  id: string
  hidden: boolean
}

const HideButton: React.FC<HideButtonProps> = ({ id, hidden }) => {
  const [, runMutation]: any[] = useMutation(hideMessageMutation)

  const hideMessage = () => {
    runMutation({ messageId: id, hide: !hidden })
      .then(
        result => {
          const { failures } = result.data.hideMessage
          if (failures.length > 0) {
            NotificationManager.error(failures[0].message)
          } else {
            NotificationManager.success(
              `This message is now ${hidden ? "visible" : "hidden"}`
            )
          }
        },
        () => NotificationManager.error("Something went wrong")
      )
      .catch(() => NotificationManager.error("Something went wrong"))
  }

  return (
    <button className="btn btn-danger btn-sm" onClick={hideMessage}>
      {hidden ? "Make Visible" : "Hide"}
    </button>
  )
}

const hideMessageMutation = gql`
  mutation Hide($messageId: ID!, $hide: Boolean!) {
    hideMessage(messageId: $messageId, hide: $hide) {
      failures {
        message
      }
      message {
        id
      }
    }
  }
`

export default HideButton
